import { NgModule } from '@angular/core';
import { NgHybridStateDeclaration, UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { ActivityElementsModule } from '../activity-categories/activity-elements.module';
import { AdditionalFeaturesSliderModule } from '../../components/additional-features-slider/additional-features-slider.module';
import { AdditionalFeaturesSliderComponent } from '../../components/additional-features-slider/additional-features-slider.component';

import { DestinationСategoriesComponent } from './destination-categories.component';

export const destinationСategories: NgHybridStateDeclaration = {
  name: 'destination-categories',
  url: '/destination/{destinationCategory}',
  component: DestinationСategoriesComponent,
  data: {
    meta: {
      'title': 'Heli List of Operators',
      'description': 'See a full list of partners and operations who offer their adventures on Heli.',
      'image': 'https://heli.life/images/new-feeds-operators.jpg'
    }
  },
  reloadOnSearch: false
};

@NgModule({
  imports: [
    UIRouterUpgradeModule.forChild({states: [destinationСategories]}),
    ActivityElementsModule,
    AdditionalFeaturesSliderModule
  ],
  declarations: [
    DestinationСategoriesComponent
  ],
  exports: [
    AdditionalFeaturesSliderComponent
  ],
  providers: [
  ]
})
export class DestinationСategoriesModule {
}